import { createContext, useContext } from 'react';
import type { BankAccountFormContextValue } from './BankAccountFormContext.types.ts';

export const BankAccountFormContext = createContext<BankAccountFormContextValue | null>(null);

export const useBankAccountFormContext = (): BankAccountFormContextValue => {
	const context = useContext(BankAccountFormContext);
	if (!context) {
		throw new Error('useBankAccountFormContext must be used within a BankAccountForm');
	}
	return context;
};
